__turbopack_context__.v({
  "calendarIcon": "EventDetails-module-scss-module__BrKLVG__calendarIcon",
  "followVenueButtonWrapper": "EventDetails-module-scss-module__BrKLVG__followVenueButtonWrapper",
  "locationIcon": "EventDetails-module-scss-module__BrKLVG__locationIcon",
  "organizerInfoWrapper": "EventDetails-module-scss-module__BrKLVG__organizerInfoWrapper",
  "presenterInfoWrapper": "EventDetails-module-scss-module__BrKLVG__presenterInfoWrapper",
  "secondaryText": "EventDetails-module-scss-module__BrKLVG__secondaryText",
  "venueAndDateTimeWrapper": "EventDetails-module-scss-module__BrKLVG__venueAndDateTimeWrapper",
  "venueRow": "EventDetails-module-scss-module__BrKLVG__venueRow",
  "wrapper": "EventDetails-module-scss-module__BrKLVG__wrapper",
});
